module.exports = __webpack_public_path__ + "static/media/loading.7617f425.svg";